import Highcharts from 'highcharts-latest';
import accessibility from 'highcharts-latest/modules/accessibility';
import HighchartsReact from 'highcharts-react-official';
import React, { useEffect, useRef } from 'react';

accessibility(Highcharts);
function SimpleChart({ options }) {
  const chartRef = useRef(null);
  useEffect(() => {
    const chart = chartRef.current.chart;
    chart.reflow();
  }, [options]);

  return (
    <div>
      <HighchartsReact
        ref={chartRef}
        highcharts={Highcharts}
        options={options}
      />
    </div>
  );
}

export default SimpleChart;
